module.exports = __webpack_public_path__ + "media/images/application/juris-65de8512c3b19a58d00c4b630ce37fb3.jpg";